import React from 'react';

const CampingIcon = (props) => {
  return (
    <img
      alt="Kemping"
      src="/static/images/icons/camping.svg"
      {...props}
    />
  );
};

export default CampingIcon;
